<template>
  <div id="data_set">
    <div class="left_tree_box drag-left-layout" :class="{ 'hidden_content': hiddenLeftTree }">
      <div class="move_box" @click="hiddenLeftTree = !hiddenLeftTree">
        <svg-icon icon-class="collapse" class="move_collapse"></svg-icon>
        <svg-icon icon-class="collapse-active" class="move_collapse_active"></svg-icon>
      </div>
      <div style="padding: 8px 4px 0 4px">
        <el-input
          v-model="searchText"
          class="self-filter-input"
          size="small"
          placeholder="搜索"
          clearable
          @keyup.enter.native="filterTree"
        >
          <i slot="suffix" style="padding-right: 8px">
            <svg-icon icon-class="input_search"></svg-icon>
          </i>
        </el-input>
      </div>

      <span class="vertical-bar fnM" :style="{ marginLeft: '16px' }">资源结构</span>
      <el-tree
        ref="resourceTree"
        style="margin-top: 16px; overflow-y: auto; height: calc(100% - 96px)"
        class="self-tree data_tree"
        node-key="id"
        :props="defaultProps"
        :data="treeData"
        :highlight-current="true"
        :filter-node-method="filterNode"
        :default-expanded-keys="defaultShowNodes"
        :expand-on-click-node="false"
        @node-click="handleNodeClick"
        @node-expand="handleNodeExpand"
        @node-collapse="handleNodeCollapse"
      >
        <span
          slot-scope="{ node }"
          :title="node.label"
          class="self-custom-tree"
          style="line-height: 32px"
        >
          <span style="padding-right: 10px"><span v-html="handleFilter(node.label)"></span></span>
        </span>
      </el-tree>
    </div>
    <div class="tree_content">
      <div class="right_content">
        <div class="search_box">
          <span class="vertical-bar fn18 fnM">数据集配置</span>
          <el-button
            size="small"
            class="float-right"
            type="primary"
            style="width: 80px"
            @click="saveRules"
          >
            保存
          </el-button>
          <el-button
            size="small"
            class="float-right plain_button"
            plain
            style="width: 80px; margin-right: 8px"
            @click="reset"
          >
            重置
          </el-button>
          <el-button
            size="small"
            class="float-right"
            type="primary"
            @click="selectSetVisible = true"
          >
            选择设置项
          </el-button>
          <el-input
            v-model="tableSearch"
            size="small"
            class="float-right"
            placeholder="请输入关键字"
            style="width: 292px"
            clearable
          >
            <i slot="suffix" style="padding-right: 8px" @click="getTableList">
              <svg-icon icon-class="input_search"></svg-icon>
            </i>
          </el-input>
          <!-- <el-select
            style="width: 292px"
            class="float-right"
            multiple
            v-model="currentSelect"
            placeholder="请选择配置项"
            collapse-tags
          >
            <el-option
              v-for="item in selectTableList"
              :key="item.resourceElementId"
              :label="$t(item.resourceElementLabel)"
              :value="item.resourceElementId"
            ></el-option>
          </el-select> -->
        </div>

        <div class="small_table">
          <customTable order height="500px" :table-data="tableData" :show-pagination="false">
            <el-table-column label="资源标识" prop="resourceElementCode"></el-table-column>
            <el-table-column label="资源名称">
              <template slot-scope="scope">
                {{ $t(scope.row.resourceElementLabel) }}
              </template>
            </el-table-column>
            <el-table-column label="自定义名称" prop="resourceElementExtendLabel"></el-table-column>
            <el-table-column>
              <template slot="header">
                设置规则
                <el-tooltip
                  effect="dark"
                  popper-class="import_excel_tooltip"
                  content="对业务字段匹配对应的数据集，实现数据权限分配的业务场景。"
                  placement="top"
                >
                  <span><svg-icon class="before_icon" icon-class="green_info"></svg-icon></span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.bizUnitId"
                  class="self-filter-input"
                  size="small"
                  style="margin: 0"
                  placeholder="请输入"
                  @change="
                    (val) => {
                      selectChange(val, scope.$index);
                    }
                  "
                >
                  <el-option
                    v-for="item in selectRulesList"
                    :key="item.id"
                    :value="item.id"
                    :label="item.bizUnitName"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="过滤字段" prop="keyField">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.keyField"
                  class="self-filter-input"
                  size="small"
                  placeholder="请输入"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="60">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  class="danger_button"
                  style="height: auto"
                  @click="
                    () => {
                      openDeleteDialog(scope.row);
                    }
                  "
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </customTable>
          <!-- 选择配置项 -->
          <el-dialog
            v-dialogDrag
            title="选择配置项"
            :visible.sync="selectSetVisible"
            class="source_dialog init_dialog"
          >
            <div style="overflow: hidden">
              <div class="small_table">
                <customTable
                  order
                  height="400px"
                  :table-data="selectTableList"
                  :show-pagination="false"
                  :checkbox="true"
                  @handleSelectionChange="tableSelectChange"
                >
                  <el-table-column label="资源标识" prop="resourceElementCode"></el-table-column>
                  <el-table-column label="资源名称">
                    <template slot-scope="scope">
                      {{ $t(scope.row.resourceElementLabel) }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="自定义名称"
                    prop="resourceElementExtendLabel"
                  ></el-table-column>
                </customTable>
              </div>
              <div
                slot="footer"
                class="dialog-footer"
                style="padding-right: 16px; text-align: right; padding: 20px 0; margin-top: "
              >
                <el-button plain size="small" style="width: 80px" @click="selectSetVisible = false">
                  取消
                </el-button>
                <el-button type="primary" size="small" @click="submitSet">确定</el-button>
              </div>
            </div>
          </el-dialog>
          <!-- 删除 -->
          <el-dialog v-dialogDrag :visible.sync="deleteVisible" class="delete_dialog">
            <div class="warning_title fnM fn16" style="padding-right: 30px">
              <svg-icon class="before_icon" icon-class="dialog_warning"></svg-icon>
              确认要删除数据“{{ $t(deleteObj.resourceElementLabel) }}”吗？
            </div>
            <div slot="footer" class="dialog-footer" style="margin-top: 36px">
              <template>
                <el-button plain size="small" style="width: 80px" @click="deleteVisible = false">
                  {{ $t("public.cancel") }}
                </el-button>
                <el-button
                  type="danger"
                  plain
                  size="small"
                  style="width: 80px"
                  @click="deleteDataSet"
                >
                  {{ $t("public.confirm") }}
                </el-button>
              </template>
            </div>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import data_api from "@/api/data-permission/dataPermission";
import { commonFilterNode } from "@/utils";
import { Message } from "element-ui";
export default {
  name: "DataSet",
  data() {
    return {
      hiddenLeftTree: false,
      searchText: "",
      filterText: "",
      treeData: [],
      defaultShowNodes: [],
      defaultProps: {
        children: "children",
        label: "resourceName"
      },
      tableData: [],
      tableSearch: "",
      selectRulesList: [],
      currentSelect: [],
      selectTableList: [],
      selectSetVisible: false,
      deleteVisible: false,
      deleteObj: {}
    };
  },
  watch: {

    /*
     * currentSelect(val) {
     *   this.tableData = [];
     *   console.log("sdfsdf");
     *   if (val.length > 0) {
     *     val.forEach((e) => {
     *       this.selectTableList.forEach((item) => {
     *         if (item.resourceElementId === e) this.tableData.push(item);
     *       });
     *     });
     *   }
     * },
     */
  },
  created() {
    const that = this;
    window.onresize = function() {
      if (document.body.clientWidth < 1400) {
        that.hiddenLeftTree = true;
      }
    };
    this.getTreeList();
    this.getRulesList();
  },
  methods: {
    // 获取table列表
    getTableList() {
      if (!this.currentNode.resourcePath) {
        // this.selectTableList = [];
        this.tableData = [];
        return;
      }
      data_api.getDataSetList(this.currentNode.resourcePath, this.tableSearch).then(res => {
        // this.selectTableList = res.data;
        this.tableData = res.data;
      });
    },
    // 重置
    reset() {
      this.getTableList();
    },
    // 获取弹窗列表
    getResourceList() {
      const params = {
        resourceId: this.currentNode.id,
        id: this.currentNode.id,
        resourceName: ""
      };
      data_api.getResourceList(params).then(res => {
        this.selectTableList = res.data;
      });
    },
    // 获取设置规则列表
    getRulesList() {
      data_api.getRulesSelectList({}).then(res => {
        this.selectRulesList = res.data;
      });
    },
    //  获取树资源
    getTreeList() {
      data_api.getResourceTree().then(res => {
        this.treeData = res.data;
        this.$nextTick(() => {
          if (!this.currentNode) {
            this.currentNode = this.treeData[0];
            this.defaultShowNodes.push(this.treeData[0].id);
          }

          this.$refs.resourceTree && this.$refs.resourceTree.setCurrentKey(this.currentNode.id);
          this.getTableList();
          this.getResourceList();
        });
      });
    },
    // 手动高亮筛选文本
    handleFilter(str) {
      if (!this.filterText || !str) { return str; }
      const index = str.indexOf(this.filterText);
      const beforeStr = str.substr(0, index);
      const afterStr = str.substr(index + this.filterText?.length);
      if (index > -1) {
        return `${beforeStr}<span style="color:#00B259;">${this.filterText}</span>${afterStr}`;
      } else {
        return str;
      }
    },
    // 筛选树
    filterTree() {
      this.filterText = this.searchText;
      this.$refs.resourceTree.filter(this.searchText);
    },
    // 节点筛选
    filterNode(value, data, node) {
      return commonFilterNode(value, data, node);
    },
    // 树节点展开
    handleNodeExpand(data) {
      // 保存当前展开的节点
      let flag = false;
      this.defaultShowNodes.some(item => {
        if (item === data.id) {
          // 判断当前节点是否存在， 存在不做处理
          flag = true;
          return true;
        }
      });
      if (!flag) {
        // 不存在则存到数组里
        this.defaultShowNodes.push(data.id);
      }
    },
    handleNodeCollapse(data) {
      this.defaultShowNodes.some((item, i) => {
        if (item === data.id) {
          // 删除关闭节点
          this.defaultShowNodes.length = i;
        }
      });
    },
    // 节点点击
    handleNodeClick(node) {
      this.currentNode = node;
      this.currentSelect = [];
      this.getTableList();
      this.getResourceList();
    },
    // 下拉选择变更
    selectChange(val, index) {
      this.selectRulesList.forEach(item => {
        if (item.id === val) {
          this.tableData[index].keyField = item.keyField;
        }
      });
    },
    // 弹窗table选择变更
    tableSelectChange(val) {
      console.log("val", val);
      this.currentSelect = val.map(item => ({ ...item, dataPermissionConfig: true }));
    },
    // 保存配置信息
    submitSet() {
      data_api.saveResource(this.currentSelect).then(res => {
        this.selectSetVisible = false;
        this.getTableList();
        Message.success("保存成功");
      });
    },
    // 保存
    saveRules() {
      if (this.tableData.length > 0) {
        data_api.saveRulesSet({ resourceUnitRelates: this.tableData }).then(res => {
          Message.success("保存成功");
          this.getTableList();
          this.getResourceList();
        });
      } else {
        Message.error("无数据可保存");
      }
    },
    //
    openDeleteDialog(obj) {
      this.deleteObj = obj;
      this.deleteVisible = true;
    },
    // 删除
    deleteDataSet() {
      const data = [];
      data.push({
        resourceElementId: this.deleteObj.resourceElementId,
        resourceId: this.deleteObj.resourceId
      });
      data_api.deleteDataSet({ relateList: data }).then(res => {
        Message.success("删除成功");
        this.deleteVisible = false;
        // 获取当前列表
      });
    }
  }
};
</script>

<style scoped lang="scss">
#data_set {
  display: flex;
  width: 100%;
  height: 100%;
  position: relative;
  .left_tree_box {
    position: relative;
    flex: 0 224px;
    width: 224px;
    transition: all 0.25s linear;
    background-color: #f9f9fb;
    .data_tree {
      -ms-overflow-style: none;
      overflow: -moz-scrollbars-none;
      .el-icon-more {
        transform: rotate(90deg);
      }
    }
    .data_tree::-webkit-scrollbar {
      width: 0 !important;
    }
  }

  .hidden_content {
    margin-left: -224px;
    flex: inherit;
  }
  .fade-left-enter-active,
  .fade-left-leave-active {
    transition: all 0.2s ease-in;
    flex: 0 224px;
  }

  .fade-left-enter-from,
  .fade-left-leave-to {
    flex: 0 0;
  }
  .tree_content {
    display: flex;
    flex: 1;
    transition: all 0.2s ease-in;
    position: relative;
    min-width: calc(100% - 224px);
    .right_content {
      flex: 1;
      padding: 24px;
      height: 100%;
      width: calc(100% - 224px);
      transition: all 0.6s ease-in;
      .search_box {
        margin-bottom: 16px;
        line-height: 32px;
        overflow: hidden;
      }
      .danger_button {
        color: #f56c6c;
      }
    }
  }

  .move_box {
    position: absolute;
    right: -34px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 50px;
    z-index: 99;
    cursor: pointer;
    .move_collapse {
      display: block;
    }

    .move_collapse_active {
      display: none;
    }

    &:hover {
      .move_collapse {
        display: none;
      }
      .move_collapse_active {
        display: block;
      }
    }
  }
  .plain_button {
    color: #505363;
    background-color: #fff;
  }
  .plain_button:hover {
    color: #00b259;
  }
  .plain_button:focus {
    color: #00b259;
  }
}
</style>

<style lang="scss">
#data_set {
  .self-filter-input {
    margin-bottom: 20px;
    .el-input__inner {
      height: 32px;
      line-height: 32px;
    }
    .el-input__icon {
      height: 32px;
      line-height: 32px;
      color: #9da5b2;
    }
  }

  .el-button--small {
    padding: 8px 16px;
    box-shadow: none;
  }
  .source_dialog {
    .el-dialog {
      width: 1006px;
      .el-dialog__header {
        padding: 24px 40px 8px 40px;
      }
      .el-dialog__body {
        padding: 6px 40px;
        .suffix_icon {
          width: 14px;
          height: 14px;
          position: relative;
          top: 1px;
          right: 5px;
        }
      }
      .dialog-footer {
        padding: 0px 20px 4px 20px;
        margin-top: 0;
      }
    }
  }

  .delete_dialog {
    .el-dialog {
      width: 500px;
      .el-dialog__header {
        padding-top: 18px;
        padding-bottom: 0;
        .el-dialog__headerbtn {
          position: absolute;
          top: 24px;
          right: 20px;
        }
      }
      .el-dialog__body {
        .warning_title {
          line-height: 22px;
          .before_icon {
            width: 24px;
            height: 22px;
            margin-right: 2px;
            vertical-align: bottom;
          }
        }
        .delete_tips {
          color: #505363;
          line-height: 20px;
          font-size: 14px;
          margin-top: 16px;
          text-indent: 32px;
        }
      }
    }
  }

  //   重写table样式-小型
  .small_table {
    .el-table {
      th {
        padding: 6px 0;
        height: 36px;
      }
      th:first-child {
        padding-left: 10px;
      }
      .el-input {
        margin-bottom: 0;
        .el-input__inner {
          height: 24px;
          line-height: 24px;
        }
      }
      td {
        padding: 4px 0;
        height: 32px;
      }
      td:first-child {
        padding-left: 10px;
      }
    }
    .el-pagination {
      padding: 0;
      .el-pagination__total {
        height: 24px;
        line-height: 24px;
      }
      button {
        height: 24px;
        line-height: 24px;
        min-width: 24px;
      }
      .el-pager {
        .number {
          height: 24px;
          line-height: 24px;
          min-width: 24px;
        }
      }
      .pagination-jumper {
        height: 24px;
        line-height: 24px;
        input {
          width: 24px;
          height: 24px;
          line-height: 24px;
        }
      }
      .pagination-sizes {
        height: 24px;
        line-height: 24px;
        .pagination-select {
          height: 24px;
          .el-input {
            .el-input__inner {
              height: 24px;
            }
          }
        }
      }
    }
  }
}
</style>
